import React, { useState } from 'react';
import { useSelector } from 'react-redux';
// import { Dropdown } from 'react-bootstrap';
// import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement } from 'chart.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faGripVertical,
  faList,
  faLock,
  faTrash,
  faCircle,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';

import { classNames } from 'utils';
// import useServiceAuth from 'auth/useServiceAuth';
import StaticData from './StaticData';
// import DropdownCustomToggle from './DropdownCustomToggle';
import { Modal } from 'react-bootstrap';
import Multiple from './RequirementMultiple';
import { Fragment } from 'react';
import { useDroppable } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CourseListDetails from './CourseListDetails';
import HistoryDetails from './HistoryDetails';
import OutsideClickHandler from 'react-outside-click-handler';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

Chart.register(ArcElement);

const Droppable = ({ id, children, disabled }) => {
  const { isOver, over, setNodeRef } = useDroppable({
    id,
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      className={classNames(isOver && over !== id && 'bg-gray-2 rounded')}
    >
      {children}
    </div>
  );
};

const Sortable = ({ id, children, disabled }) => {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    backgroundColor: 'white',
    opacity: isDragging ? 0.75 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      role={!disabled ? 'button' : undefined}
      tabIndex={disabled ? -1 : 0}
      className={classNames(disabled && 'focus-off', 'requirement-drag')}
    >
      {children}
    </div>
  );
};

const showHistoryIcon = (req) => {
  if (req && req.length > 1) {
    return true;
  } else if (req && req.length === 1) {
    console.log('req[0].action: ', req[0].action);
    return (
      req[0].action !== 'REQUIREMENT-ADDED' &&
      req[0].action !== 'SUBSECTION-ADDED'
    );
  }
  return false;
};

const RequirementRow = ({
  req,
  reqIndex,
  isLocked = false,
  holdsLock = false,
  handleOpenEditModal,
  refetchChecksheet,
  updateData = null,
  courseLists = null,
  readOnly = false,
  history = null,
  historySubsections = null,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const removeRow = async () => {
    console.log('req: ', req);
    const confirmDeletion = window.confirm(
      'Are you sure you want to delete this data?'
    );
    if (confirmDeletion)
      updateData(
        req.index,
        req.itemType,
        null,
        req.section,
        req.subsection,
        false,
        false,
        req.requirementId
      );
  };

  const handleOpenHistory = (isMenuOpen) => {
    setIsMenuOpen(isMenuOpen);
  };
  const handleCloseHistory = () => {
    setIsMenuOpen(false);
  };

  const CourseListAccordion = ({ course }) => {
    const [showCourseList, setShowCourseList] = useState(false);

    // console.log('Courses: ', courseLists[course.courseListId]?.courses);

    const handleShowCourseList = (e) => {
      e.stopPropagation();
      setShowCourseList(!showCourseList);
    };

    return (
      <>
        <span className="button-link" onClick={(e) => handleShowCourseList(e)}>
          <FontAwesomeIcon
            icon={faChevronDown}
            className={classNames(showCourseList && 'rotate-180')}
            style={{ margin: '0 4px' }}
          />
          {showCourseList ? 'Hide course list' : 'Show course list'}
        </span>
        {showCourseList && (
          <CourseListDetails
            courseListName={courseLists[course.courseListId]?.courseListName}
            courses={courseLists[course.courseListId]?.courses || []}
            edit={false}
            division={course.division}
          />
        )}
      </>
    );
  };

  return (
    <>
      <div role={isLocked && holdsLock ? 'button' : undefined}>
        {req.itemType === 'req_multiple' && (
          <div
            className={classNames(
              isLocked && holdsLock && 'hoverable',
              'row py-2 mx-0 border border-top-0 border-gray-3'
            )}
          >
            <div className="d-flex gap-1" style={{ width: '76%' }}>
              {isLocked && holdsLock && !readOnly ? (
                <div className="d-flex">
                  <FontAwesomeIcon
                    icon={faGripVertical}
                    className="text-gray-4"
                    style={{ width: '15px', marginRight: '5px' }}
                  />
                  {req?.requirementId &&
                    !!history &&
                    history[req.requirementId] &&
                    showHistoryIcon(history[req.requirementId]) && (
                      <OutsideClickHandler
                        onOutsideClick={() => handleOpenHistory(false)}
                      >
                        <div className="position-relative">
                          <div
                            className={classNames(
                              isMenuOpen
                                ? 'visible opacity-100'
                                : 'invisible opacity-0',
                              'history-menu-container bg-white px-2 py-2 border border-gray-3'
                            )}
                          >
                            <div className="mini-menu-item">
                              {isMenuOpen && (
                                <HistoryDetails
                                  // data={[
                                  //   ...history[req.requirementId],
                                  // ].reverse()}
                                  historyRequirements={
                                    history[req.requirementId]
                                  }
                                  handleClose={handleCloseHistory}
                                />
                              )}
                            </div>
                          </div>
                          <div
                            className={classNames(
                              isMenuOpen && 'bg-gray-3',
                              'vertical-ellipsis p-0 lh-1 rounded-1'
                            )}
                          >
                            <FontAwesomeIcon
                              icon={faCircle}
                              className="text-teal underline-hover"
                              title="See changes"
                              style={{ width: '10px', paddingTop: '4px' }}
                              onClick={() => handleOpenHistory(true)}
                            />
                          </div>
                        </div>
                      </OutsideClickHandler>
                    )}
                </div>
              ) : (
                <div className="pe-0" style={{ width: '3%' }}>
                  <FontAwesomeIcon icon={faLock} />
                </div>
              )}

              <div
                onClick={
                  isLocked && holdsLock
                    ? (e) => {
                        e.stopPropagation();
                        handleOpenEditModal(
                          req.index,
                          req,
                          req.subsection,
                          req.section
                        );
                      }
                    : undefined
                }
                style={{
                  cursor: readOnly ? 'not-allowed' : undefined,
                  width: '91%',
                }} // Visual indication when disabled
              >
                {req.courses.map((course, index) => (
                  <Fragment key={index}>
                    <span className="requirement">
                      {course.connector && (
                        <>
                          {course.connector !== 'or' && index !== 0 && <br />}
                          <span
                            className={classNames(
                              course.connector,
                              'fw-bold rounded-1 text-nowrap'
                            )}
                          >
                            {course.connector}
                          </span>
                        </>
                      )}
                      <span className="hover-text">
                        {course.itemType === 'req_check' &&
                        course.checkType === 'gpa' ? (
                          <>
                            <span className="fw-bold">Check</span>:{' '}
                          </>
                        ) : (
                          course.checkType === 'milestone' && (
                            <>
                              <span className="fw-bold">Milestone</span>:{' '}
                            </>
                          )
                        )}
                        {course.gpa && `Minimum ${course.gpa} `}
                        {course.checkSubtype === 'asu_cum_gpa' &&
                          'ASU Cumulative GPA'}
                        {course.checkSubtype === 'major_gpa' && 'Major GPA'}
                        {(course.checkSubtype === 'subject' ||
                          course.checkSubtype === 'courses') &&
                          `GPA in `}
                        {course.checkSubtype === 'subject' && 'all '}
                        {course.checkSubtype === 'courses' &&
                          course.checkCourses &&
                          course.checkCourses.map(
                            (checkCourse, index, array) => (
                              <span key={index}>
                                {index !== 0 &&
                                  index === array.length - 1 &&
                                  'and '}
                                {checkCourse.subject} {checkCourse.number}
                                {array.length > 2 && index < array.length - 1
                                  ? ', '
                                  : ' '}
                              </span>
                            )
                          )}
                        {course.milestone && (
                          <span>{Object.values(course.milestone)[0]}</span>
                        )}
                        {course.subject && (
                          <span
                            className={classNames(
                              course.itemType !== 'req_check' && 'fw-bold'
                            )}
                          >
                            {course.subject}{' '}
                          </span>
                        )}
                        {course.number && (
                          <>
                            <span className="fw-bold">{course.number}</span>:{' '}
                          </>
                        )}
                        {course?.topic?.description ? (
                          course.topic.description
                        ) : course.proposedTitle ? (
                          <span>
                            {course.proposedTitle}
                            <span className="text-warning-custom bg-warning-custom fw-bold mx-1 px-1">
                              Proposed
                            </span>
                          </span>
                        ) : (
                          course.description
                        )}
                        {!!course.division && course.division.trim()
                          ? (course.division === 'Upper' ||
                            course.division === 'Lower'
                              ? course.division + ' Division'
                              : course.division + '-Level') +
                            (course.itemType !== 'req_course_list' ? ' ' : '')
                          : ''}
                        {course.checkSubtype === 'subject' && ' courses'}
                        {course.group && course.group + ': '}
                        {course.groupIndex !== 'custom_text' && course.text}
                        {parse(DOMPurify.sanitize(course.customText), {
                          replace: (domNode) => {
                            if (
                              domNode.type === 'tag' &&
                              domNode.name === 'a'
                            ) {
                              return (
                                <a
                                  {...domNode.attribs}
                                  onClick={(e) => e.stopPropagation()}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {domNode.children.map((child, index) => {
                                    // Handle text nodes directly
                                    if (child.type === 'text') {
                                      return child.data;
                                    }
                                    // For other nodes, recursively parse them
                                    return parse(
                                      DOMPurify.sanitize(child.data),
                                      {
                                        replace: (innerNode) => {
                                          if (
                                            innerNode.type === 'tag' &&
                                            innerNode.name === 'a'
                                          ) {
                                            return (
                                              <a
                                                key={index}
                                                {...innerNode.attribs}
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                {innerNode.children[0].data}
                                              </a>
                                            );
                                          }
                                        },
                                      }
                                    );
                                  })}
                                </a>
                              );
                            }
                          },
                        })}
                        {course.gs && course.subject && (
                          <span> ({course.gs})</span>
                        )}
                        {course.itemType === 'req_gs' && !!course.gs && (
                          <>
                            {
                              StaticData.gsList.find(
                                (gs) => gs.value === course.gs
                              ).label
                            }{' '}
                            ({course.gs})
                          </>
                        )}
                        {(course.itemType === 'req_elective' ||
                          course.itemType === 'req_subject') &&
                          'Elective'}
                        {!!course?.recommended?.courses?.length && (
                          <>
                            <br />
                            <span style={{ marginLeft: '55px' }}>
                              <span className="fst-italic">Recommended:</span>
                              {course.recommended.courses.map(
                                (c, ind, array) => (
                                  <span key={ind}>
                                    {ind !== 0 &&
                                      !c.connector?.trim(' ') &&
                                      'or '}
                                    {c.connector} {c.subject} {c.number}
                                    {!!c.proposedTitle && (
                                      <span className="text-warning-custom bg-warning-custom fw-bold mx-1 px-1">
                                        Proposed
                                      </span>
                                    )}{' '}
                                  </span>
                                )
                              )}
                            </span>
                          </>
                        )}
                        {courseLists && courseLists[course.courseListId] && (
                          <span className="fw-bold underline-hover mx-1">
                            <FontAwesomeIcon
                              icon={faList}
                              style={{ marginRight: '4px' }}
                            />
                            {courseLists[course.courseListId]?.courseListName ||
                              'Untitled course list'}
                          </span>
                        )}
                      </span>
                      {courseLists && courseLists[course.courseListId] && (
                        <CourseListAccordion course={course} />
                      )}
                    </span>
                  </Fragment>
                ))}
              </div>
            </div>
            <div
              style={{
                flexBasis: 'auto',
                width: '9%',
                fontSize: '14px',
              }}
              className={classNames(
                (!req.grade || !req.grade.trim()) && 'text-gray-4',
                'text-nowrap'
              )}
            >
              {req.grade && req.grade.trim() ? req.grade : '\u2014'}
            </div>
            <div
              style={{ flexBasis: 'auto', width: '11%' }}
              className="d-flex justify-content-end"
            >
              <div
                className={classNames(
                  !!req.hours
                    ? 'bg-gray-2 fw-semibold rounded-pill'
                    : 'text-gray-4',
                  'text-nowrap text-end lh-1'
                )}
                style={{
                  fontSize: '14px',
                  height: 'fit-content',
                  padding: '5px 8px',
                }}
              >
                {!!req.hours ? `${req.hours}` : '\u2014'}
                {!!req.maxHours &&
                  req.maxHours !== 0 &&
                  req.maxHours !== req.hours &&
                  `${' - '} ${req.maxHours}`}
              </div>
            </div>
            <div style={{ width: '4%' }}>
              {isLocked && holdsLock && !readOnly && (
                <FontAwesomeIcon
                  icon={faTrash}
                  title="Delete requirement"
                  onClick={removeRow}
                  className="deleteButton text-gray-6"
                  style={{ width: '15px', marginRight: '5px' }}
                />
              )}
            </div>

            {req.notes && (
              <div className="notes row align-items-center pt-1 m-0">
                <div
                  className="py-0 px-4"
                  style={{
                    flexBasis: 'auto',
                    width: '55%',
                    fontSize: '14px',
                  }}
                >
                  {parse(DOMPurify.sanitize(req.notes), {
                    replace: (domNode) => {
                      if (domNode.type === 'tag' && domNode.name === 'a') {
                        return (
                          <a
                            {...domNode.attribs}
                            onClick={(e) => e.stopPropagation()}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {domNode.children.map((child, index) => {
                              // Handle text nodes directly
                              if (child.type === 'text') {
                                return child.data;
                              }
                              // For other nodes, recursively parse them
                              return parse(DOMPurify.sanitize(child.data), {
                                replace: (innerNode) => {
                                  if (
                                    innerNode.type === 'tag' &&
                                    innerNode.name === 'a'
                                  ) {
                                    return (
                                      <a
                                        key={index}
                                        {...innerNode.attribs}
                                        onClick={(e) => e.stopPropagation()}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {innerNode.children[0].data}
                                      </a>
                                    );
                                  }
                                },
                              });
                            })}
                          </a>
                        );
                      }
                    },
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

const OrphanedRequirements = ({
  orphans,
  year,
  edit = false,
  checksheet = false,
  refetchChecksheet,
  validation = null,
  refetchValidation,
  isLocked = false,
  holdsLock = false,
  openEditModal = null,
  // modalSetAsRequirement,
  dataToModal = null,
  dataToParent = null,
  updateData = null,
  updateSubsection = null,
  readOnly = false,
  history = null,
  historySubsections = null,
}) => {
  // const { getAccessToken } = useServiceAuth();

  const [currentSection, setCurrentSection] = useState('');
  const [showModal, setShowModal] = useState(false);

  const courseLists = useSelector((state) => state.checksheet.courseLists);

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentSection('');
  };

  const receiveDataFromModal = (data) => {
    console.log('Received data from modal-----:' + JSON.stringify(data));
    const subsectionId =
      data.subsectionId && data.subsectionId !== '999'
        ? data.subsectionId
        : data.componentId; // use componentId as subsectionId if subsectionId is not provided (main subsection)

    if (data) {
      updateData(
        data.index,
        data.type,
        data.details,
        data.componentId,
        subsectionId,
        data.oldIndex, // oldIndex is used to remove the old requirement from the list
        data.oldSubsectionId //   OldSubsectionId is used to remove the old requirement from the list
      );
    }
  };

  //add index and req type to data. We need to know the index when data sent back from child component
  //and what type of the requirment it is.
  const createWrappedData = (
    index,
    type,
    details,
    componentId,
    subsectionId,
    oldIndex,
    oldSubsectionId
  ) => {
    const wrappedData = {
      index: index,
      type: type,
      details: details,
      componentId: componentId,
      subsectionId: subsectionId,
      oldIndex: oldIndex,
      oldSubsectionId: oldSubsectionId,
    };
    console.log('wrap data for component:---- ', details);
    return wrappedData;
  };

  const handleOpenEditModal = (index, data, subsectionId, sectionId) => {
    setCurrentSection(sectionId);
    openEditModal(index, 'req_multiple', data, sectionId, subsectionId);
    if (checksheet) setShowModal(true);
  };

  return (
    <>
      <div className="border border-gray-4 border-dashed border-2 rounded p-3 mb-9">
        <div className="d-flex gap-1 align-items-center py-1 ps-2 mb-4 border-start border-4 border-danger">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="text-danger"
            style={{ width: '20px', height: '20px' }}
          />
          <h3 className="m-0">Section or subsection no longer exists</h3>
        </div>
        <p style={{ width: '65%' }}>
          For this catalog year, one or more sections or subsections have been
          permanently removed. The following requirements must now be reviewed
          and moved to an appropriate section/subsection, or deleted if no
          longer needed.
        </p>
        <Droppable id="@orphanSubsection@orphanSection" disabled={true}>
          <div
            className={classNames(
              !!orphans.subsections.orphanSubsection.requirements.length &&
                'mb-5'
            )}
          >
            <div className="row px-0 py-1 m-0 fw-bold border-bottom border-2 border-gray-7">
              <div
                className="ps-0"
                style={{
                  flexBasis: 'auto',
                  width: '76%',
                }}
              >
                Requirement
              </div>
              <div
                style={{ flexBasis: 'auto', width: '9%' }}
                className="text-nowrap"
              >
                Min Grade
              </div>
              <div
                style={{ flexBasis: 'auto', width: '11%' }}
                className="text-end text-nowrap"
              >
                Credit Hours
              </div>
              {edit && <div style={{ flexBasis: 'auto', width: '6%' }} />}
            </div>
            <SortableContext
              items={orphans.subsections.orphanSubsection.requirements.map(
                (req) => `${req.requirementId}@orphanSubsection@orphanSection`
              )}
              strategy={verticalListSortingStrategy}
            >
              {orphans.subsections.orphanSubsection.requirements.map(
                (req, index) => (
                  <Sortable
                    key={req.requirementId}
                    id={`${req.requirementId}@orphanSubsection@orphanSection`}
                    disabled={!holdsLock}
                  >
                    <RequirementRow
                      req={req}
                      reqIndex={index}
                      isLocked={isLocked}
                      holdsLock={holdsLock}
                      handleOpenEditModal={handleOpenEditModal}
                      refetchChecksheet={refetchChecksheet}
                      updateData={updateData}
                      courseLists={courseLists}
                      readOnly={readOnly}
                      //   history = null,
                      //   historySubsections = null
                    />
                  </Sortable>
                )
              )}
            </SortableContext>
          </div>
        </Droppable>
      </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Multiple
          componentId={currentSection}
          year={year}
          componentName={currentSection}
          dataFromParent={dataToModal}
          dataToParent={(newData) => receiveDataFromModal(newData)}
          createWrappedData={createWrappedData}
          exitRequirement={handleCloseModal}
          fromChecksheet={true}
          readOnly={readOnly}
          isLocked={isLocked}
          holdsLock={holdsLock}
          orphaned={true}
          refetchValidation={refetchValidation}
        />
      </Modal>
    </>
  );
};

export default OrphanedRequirements;
